(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noraviro-expectations"] && !Shopify.designMode) return;
  try {
    
function initNoraviroTabs(scope){scope.querySelectorAll('.nv-expect').forEach(section=>{if(section.dataset.tabsReady)return;section.dataset.tabsReady='true';const tabs=[...section.querySelectorAll('[role="tab"]')];const panels=[...section.querySelectorAll('[role="tabpanel"]')];function select(index){tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;});}tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>select(i));tab.addEventListener('keydown',event=>{let next=i;if(event.key==='ArrowRight')next=(i+1)%tabs.length;else if(event.key==='ArrowLeft')next=(i+tabs.length-1)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();select(next);tabs[next].focus();});});});}initNoraviroTabs(document);document.addEventListener('shopify:section:load',()=>initNoraviroTabs(document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noraviro-ingredients"] && !Shopify.designMode) return;
  try {
    
function initializeIngredientGallery(root){
 if(root.dataset.initialized)return;
 root.dataset.initialized='true';
 const track=root.querySelector('.nv-ingredient-track');
 const prev=root.querySelector('[data-ingredient-prev]');
 const next=root.querySelector('[data-ingredient-next]');
 const update=()=>{prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2};
 const move=direction=>track.scrollBy({left:direction*track.querySelector('article').getBoundingClientRect().width,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
 prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
 track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);update();
}
document.querySelectorAll('.nv-ingredient-gallery').forEach(initializeIngredientGallery);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.nv-ingredient-gallery').forEach(initializeIngredientGallery));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noraviro-sale-bar"] && !Shopify.designMode) return;
  try {
    
(() => {
  const start = scope => {
    scope.querySelectorAll('[data-nv-halloween]').forEach(root => {
      if (root.dataset.started) return;
      root.dataset.started = 'true';
      const deadline = Date.parse(root.dataset.deadline);
      let interval;
      const tick = () => {
        if (!root.isConnected) { clearInterval(interval); return; }
        const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        if (!Number.isFinite(remaining) || remaining === 0) {
          root.hidden = true;
          clearInterval(interval);
          return;
        }
        const values = {days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60};
        Object.entries(values).forEach(([key, value]) => { root.querySelector('[data-' + key + ']').textContent = String(value).padStart(2, '0'); });
      };
      tick();
      if (!root.hidden) interval = setInterval(tick, 1000);
      root.nvHalloweenCleanup = () => clearInterval(interval);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document), {once:true});
  else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-nv-halloween]').forEach(root => root.nvHalloweenCleanup?.()));
})();

  } catch(e) { console.error(e); }
})();
})();
